import { render, staticRenderFns } from "./dividend.vue?vue&type=template&id=43ac69b3"
import script from "./dividend.vue?vue&type=script&lang=js"
export * from "./dividend.vue?vue&type=script&lang=js"
import style0 from "./dividend.vue?vue&type=style&index=0&id=43ac69b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports